import CheckboxField from './Checkbox'
import SelectField from './Select'
import SelectInput from './SelectInput'
import DatePicker from '../../date-picker'
import Input from '../../input'
import InputNumber from '../../input-number'

export const defaultFieldWidth = '200px'

export const getFieldWidth = (type) => {
  if (type === 'dateRange') {
    return '340px'
  }

  return (
    {
      dateRange: '340px',
      selectInput: '320px',
    }[type] || defaultFieldWidth
  )
}

export default {
  string: Input,
  input: Input,
  search: Input.Search,
  inputNumber: InputNumber,
  number: InputNumber,
  select: SelectField,
  checkbox: CheckboxField,
  date: DatePicker,
  dateRange: DatePicker.RangePicker,
  selectInput: SelectInput,
}
